import { useParams } from "react-router-dom";
import { ProfileAvatar } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { GetPatientInfo } from "../../../interface/GeneralResponse";
import { truncateText } from "../../../utils/stringsUtils";
import { formatAge, normalizeGender } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Ic_phone from "../../../assets/images/icons/black-phone.svg";
import { RootState } from "../../../redux/store";
import { useGetData } from "../../../hooks";
import { NotificationsLoader } from "../../../Share";

const PatientInfoCard = () => {
  const { PatientId } = useParams();

  const { t } = useTranslation();

  const { data, isLoading } = useGetData<GetPatientInfo>(
    EndPoints.GetPatients,
    { refetchOnWindowFocus: true, enabled: !!PatientId },
    PatientId,
  );

  const patientInfo = data?.Data;

  const UserInfo = useSelector((state: RootState) => state.registration);

  return (
    <div className="">
      {isLoading ? (
        <NotificationsLoader />
      ) : (
        <>
          <div className="flex items-center gap-4 pt-2">
            <ProfileAvatar
              Id={patientInfo?.Id}
              className="h-20 !w-16 rounded-lg object-cover"
              src={patientInfo?.Image}
              alt={truncateText(patientInfo?.FullName ?? "", 10)}
              FullName={patientInfo?.FullName}
            />
            <div className="flex flex-col">
              <p className="font-bold">{patientInfo?.FullName}</p>
              <p className="text-body-text">
                {patientInfo?.Birthday &&
                  formatAge(patientInfo?.Birthday || "", true)}{" "}
                {t("years_old")} . {normalizeGender(patientInfo?.Gender)}
              </p>
              <p className="flex gap-2">
                <img src={Ic_phone} alt="Phone Icon" />
                <span dir="ltr">
                  {patientInfo?.PhoneNumber &&
                    UserInfo.userDetails.Country?.Code +
                      "-" +
                      patientInfo?.PhoneNumber}
                </span>
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PatientInfoCard;
